import { ManualButton } from "./navbar/manual_button";
import { NavbarBase } from "./NavbarBase";

export function StaticNavbar() {
	return (
		<>
			<NavbarBase is_fixed>
				<div className="column is-narrow topnav-right hidden sm:block">
					<div className="columns is-vcentered is-mobile">
						<div className="column is-narrow is-hidden-mobile">
							<ManualButton className="manual-link" />
						</div>
						<div className="column is-narrow is-hidden-mobile">
							<a href="/premium">Premium</a>
						</div>
						<div className="column is-narrow is-hidden-mobile">
							<a href="/blog">Blog</a>
						</div>
						<div className="column is-narrow is-hidden-mobile">
							<a href="/dashboard">Dashboard</a>
						</div>
					</div>
				</div>
				<div className="block px-3 sm:hidden">
					<div className="flex items-center gap-4">
						<div className="">
							<a href="/manual" suppressHydrationWarning={true}>
								<i
									className="icon fas fa-book"
									suppressHydrationWarning={true}
								></i>
							</a>
						</div>
						<div className="">
							<a href="/premium" suppressHydrationWarning={true}>
								<i
									className="icon fas fa-gem"
									suppressHydrationWarning={true}
								></i>
							</a>
						</div>

						<div className="">
							<a href="/blog" suppressHydrationWarning={true}>
								<i
									className="icon fas fa-newspaper"
									suppressHydrationWarning={true}
								></i>
							</a>
						</div>
						<div className="">
							<a href="/dashboard">Dashboard</a>
						</div>
					</div>
				</div>
			</NavbarBase>
			<nav className="topnav mock-bar !hidden sm:!block" aria-hidden>
				<div className="columns is-vcentered is-centered">
					<div className="column is-10">
						<div className="columns is-vcentered">
							<div className="column is-narrow">
								<img
									src={"/static/logo2transparent.png"}
									alt="Sesh Logo"
									className="header-logo"
								/>
							</div>
							<div className="column is-narrow topnav-right">
								<div className="columns">
									<div className="column is-narrow">
										<a className="manual-link">Manual</a>
									</div>
									<div className="column is-narrow">
										<a>Premium</a>
									</div>
									<div className="column is-narrow">
										<a>Dashboard</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</nav>
		</>
	);
}
